function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.52576 0.202808C4.10258 0.312682 3.75203 0.406866 3.74677 0.412082C3.74147 0.417299 4.56136 1.80433 5.56872 3.49434C6.57603 5.18438 7.38678 6.57841 7.37038 6.59224C7.33377 6.62301 3.09422 7.72111 3.01454 7.72042C2.98323 7.72018 2.57416 7.42901 2.10548 7.07339C1.63685 6.7178 1.24239 6.42652 1.22891 6.42607C1.167 6.42421 0.0316279 6.72569 0.000321586 6.75234C-0.0273532 6.77591 1.73928 9.80944 2.16801 10.4746L2.26177 10.62L5.03071 9.90257C6.55361 9.50796 9.88465 8.64547 12.433 7.9859C14.9813 7.32634 17.1451 6.75007 17.2413 6.70535C17.6311 6.5243 17.9389 6.09597 17.9922 5.66068C18.0848 4.90316 17.3419 4.16911 16.572 4.25743C16.457 4.27061 15.3035 4.55595 14.0087 4.89144C12.7138 5.22696 11.6297 5.49584 11.5996 5.48901C11.5695 5.48214 10.1799 4.2436 8.51168 2.73674C6.3366 0.772115 5.45251 -0.00217912 5.38681 4.60491e-06C5.33638 0.00166262 4.94893 0.0929344 4.52576 0.202808ZM0.515707 14.1508V15H8.98929H17.4629V14.1508V13.3015H8.98929H0.515707V14.1508Z",
  fill: "#979797"
});

var SvgFlightTakeoff = function SvgFlightTakeoff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFlightTakeoff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flight-takeoff.d536b917.svg";
export { ForwardRef as ReactComponent };